module.exports = __webpack_public_path__ + "img/sceau.64fa3918.jpeg";